module.exports = __webpack_public_path__ + "static/media/internal_env_3_media_12.fa4f9b01.webp";